import { Link } from "react-router-dom";
import styled from "styled-components";

export const Container = styled.div`
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
`;

export const Header = styled.nav`
    width: 100%;
    height: 64px;
    background-color: #fff;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 32px;
    box-shadow: 0px 4px 16px rgba(216, 224, 242, 0.8);
`;

export const Title = styled.h5`
    /* color: #f5f6f8; */
    margin: 0;
`;

export const SignoutLink = styled(Link)`
    display: flex;
    align-items: center;
    font-size: 16px;
`;

export const PageContent = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 32px;
    height: 100%;
    width: 100%;
`;

export const Item = styled.button`
    width: 620px;
    border-radius: 8px;
    margin-right: 20px;
    background-color: transparent;
    display: flex;
    flex-direction: column;
    padding: 16px;
    border: none;
    border-bottom: 1px solid grey;
    margin: 0;

    @media (max-width: 720px) {
        max-width: 620px;
        width: 100%;
    }
`;

export const ItemView = styled.div`
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
`;
export const ItemViewGroup = styled.div`
    display: flex;
    align-items: center;
    width: 100%;
`;

export const ItemInfoView = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    margin-left: 8px;
    width: 100%;
`;

export const OrganizationName = styled.strong`
    font-size: 16px;
    margin: 0;
`;

export const OrganizationId = styled.span`
    font-size: 14px;
    margin: 0;
`;

export const Icon = styled.span`
    display: inline-block;
    font-size: 35px;
`;

export const InputGroup = styled.div`
    display: flex;
    width: 620px;
    align-items: center;
    justify-content: center;
    background-color: #fff;
    @media (max-width: 720px) {
        max-width: 620px;
        width: 100%;
    }
    height: 40px;
    padding: 8px;
    margin-bottom: 16px;
    border-radius: 5px;
`;

export const Input = styled.input`
    width: 100%;
    height: 100%;
    border: none;

    &:focus {
        outline: none !important;
    }
`;
